<template>
  <b-modal
    :id="modalId"
    :show.sync="show"
    centered
    hide-header
    :cancel-title="$t('button.cancel.label')"
    cancel-variant="danger"
    :ok-title="$t('button.save.label')"
    ok-variant="success"
    :ok-disabled="!form.content"
    footer-bg-variant="dark"
    @show="onShow"
    @ok="onOk"
    @cancel="onClose"
  >
    <div>
      <b-form-textarea
        id="input-content"
        ref="content"
        v-model="form.content"
        :placeholder="$t('form.supportRequestContent.placeholder')"
        :rows="5"
        autofocus
        :state="validateState('content')"
      ></b-form-textarea>
    </div>
  </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

import addSupportRequest from '@/api/support/mutations/addSupportRequest.gql';

export default {
  name: 'NewRequestModal',
  mixins: [validationMixin],
  props: {
    modalId: {
      type: String,
      required: true,
    },
    boxId: {
      type: String,
    },
    direction: {
      type: String,
    },
  },
  data() {
    return {
      show: false,
      form: {
        content: '',
      },
    };
  },
  validations: {
    form: {
      content: {
        required,
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onClose() {
      this.show = false;
    },
    onOk() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        this.form._invalidSave = true;
        return;
      }

      this.$apollo
        .mutate({
          mutation: addSupportRequest,
          variables: {
            boxId: this.boxId,
            content: this.form.content,
            directionId: this.direction || 'SUP',
          },
          refetchQueries: [],
        })
        .then(() => {
          this.$bvToast.toast(this.$t('support.newRequest.successMessage'), {
            title: this.$t('toast.success'),
            variant: 'success',
            solid: true,
          });
        })
        .catch((e) => {
          this.$bvToast.toast(this.$t('support.newRequest.failedMessage'), {
            title: this.$t('toast.error'),
            variant: 'danger',
            solid: true,
          });
          console.log(e.message);
        });
      this.onClose();
    },
    onShow() {
      this.form = { content: '' };
      this.$v.form.$reset();
    },
  },
};
</script>
